import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const domainSuggestionsAi = async _ref => {
  let httpClient = _ref.httpClient,
    _ref$request = _ref.request,
    domain = _ref$request.domain,
    aiChatMessages = _ref$request.aiChatMessages,
    domainsCount = _ref$request.domainsCount;
  const parsedDomain = domain != null && domain.main ? domain : parseDomain(domain);
  const validDomainName = parsedDomain.fullAsciiDomain;
  let domainNamesToSuggest = [];
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    domainsGptSuggestions = _await$dynamicLoadApi.domainsGptSuggestions,
    suggestDomains = _await$dynamicLoadApi.suggestDomains;
  const _await$domainsGptSugg = await domainsGptSuggestions({
      similarTo: [parsedDomain.formattedInput],
      domainsCount,
      fallbacksCount: 3,
      secureAvailability: true,
      descriptions: [`
        Please use the following messages to generate domain suggestions:
        ${aiChatMessages.map(message => `- ${message.role}: ${message.content}`).join('\n')}
        ** If domain name is included in the request please take it into account. when generating suggestions.
        ** Don't include the domain name in the suggestions.
        `]
    }),
    domainNames = _await$domainsGptSugg.domainNames;
  domainNamesToSuggest = [...domainNames];
  if (domainNames.length < domainsCount) {
    var _ref2;
    const _await$suggestDomains = await suggestDomains({
        query: validDomainName,
        paging: {
          limit: domainsCount + 2 - domainNames.length
        }
      }),
      suggestions = _await$suggestDomains.suggestions;
    domainNamesToSuggest = [...domainNamesToSuggest, ...((_ref2 = suggestions ?? []) == null ? void 0 : _ref2.map(suggestion => suggestion.domain))];
  }
  return {
    suggestions: domainNamesToSuggest
  };
};
//# sourceMappingURL=domainSuggestionsAi.js.map